import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
  },
  divider: {
    position: 'absolute',
  },
  chips: {
    paddingLeft: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  alertShippingRestrictions: {
    width:'fit-content',
    marginLeft:44
  },
  paragraphStatement: {
    fontSize: 10,
    lineHeight:theme.spacing(1.5),
    marginBottom: theme.spacing(2),
    fontWeight:'bold',
    fontStyle:'italic',
    padding: theme.spacing(0,6,0,6),
    color: theme.palette.neutral.main,
  },

  // ROW
  row: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(1),
  },
  rowHasError: {
    marginBottom: theme.spacing(4),
  },
  rowErrors: {
    position: 'absolute',
    left: 28,
    top: '100%',
    transform: 'translateY(-0.4em)',
  },
  rowIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    margin: theme.spacing(0.5, 2, 0.5, 0.5),
    height: theme.spacing(3),
    width: theme.spacing(3),

    backgroundColor: theme.palette.primary.main,

    color: theme.palette.neutral.white,
    fontWeight: 700,

    borderRadius: '50%',
  },
  input: {
    width: 120,

    '& .MuiInputBase-input': {
      height: 35,
    },
  },
  actionWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: theme.spacing(6.5),
    height: theme.spacing(4),
  },
  actionButton: {
    marginBottom: theme.spacing(0.25),
    color: theme.palette.primary.main,
  },
}))

export default useStyles
